.citation_class {
    font-size: 12px;
    color: #31568e;
    font-weight: 700;
    font-style: normal;
}

.scrollFadeContent {
    padding-top: 40px;
}
